import React, { useState } from 'react';
import Modal from './Modal';
import './styles/components.css';


const EditButton = ({ item, formConfig, onEdit }) => {
  const [open, setOpen] = useState(false);
  const [values, setValues] = useState({});
  const [loading, setLoading] = useState(false);
  const [feedback, setFeedback] = useState(null);

  const handleOpen = () => {
    const initialValues = (formConfig || []).reduce((acc, field) => {
      acc[field.name] = item[field.name] !== undefined && item[field.name] !== null
        ? String(item[field.name])
        : '';
      return acc;
    }, {});
    setValues(initialValues);
    setOpen(true);
  };

  const handleChange = e => {
    setValues({ ...values, [e.target.name]: e.target.value });
  };

  const handleSubmit = async e => {
    e.preventDefault();
    setLoading(true);
    setFeedback(null);
    await onEdit(values, success => {
      setLoading(false);
      setFeedback(success ? 'Editado correctamente' : 'Error al editar');
      if (success) {
        setTimeout(() => {
          setOpen(false);
          setFeedback(null);
        }, 1000);
      }
    });
  };

  return (
    <>
      <button className="edit-btn" onClick={handleOpen}>
        Editar
      </button>
      {open && (
        <Modal
          title="Editar"
          onClose={() => setOpen(false)}
          actions={
            <div className="modal-actions">
              <button type="submit" className="edit-btn" disabled={loading} form="edit-form">
                {loading ? 'Guardando...' : 'Guardar Cambios'}
              </button>
              <button type="button" className="close-btn" onClick={() => setOpen(false)}>
                Cerrar
              </button>
            </div>
          }
        >
          <form id="edit-form" onSubmit={handleSubmit}>
            {formConfig.map(field => (
              <div key={field.name} style={{ marginBottom: 12 }}>
                <input
                  type={field.type}
                  name={field.name}
                  value={values[field.name] || ''}
                  onChange={handleChange}
                  required
                  placeholder={item[field.name] || `Ingrese ${field.label.toLowerCase()}`}
                />
              </div>
            ))}
            {feedback && <div style={{ marginTop: 10 }}>{feedback}</div>}
          </form>
        </Modal>
      )}
    </>
  );
};

export default EditButton;
